<template>
  <div class="container" >
    <div v-if="$store.state.user && !$store.state.user.superusuario">No está autorizado</div>
    <b-container class="bv-example-row" v-if="$store.state.user && $store.state.user.superusuario">
      <b-row>
        <b-col>
          <b-card-group deck>
            <b-card header="Seleccionar Usuario" v-if="users">
              <b-button variant="info" @click="add">Agregar Usuario</b-button>
              <b-form-input v-model="search_user" placeholder="Buscar..."></b-form-input>

              <b-list-group>
                <b-list-group-item v-for="user in getUsers()" v-bind:key="user.id">
                  <a href="#" @click="selected=user">{{user.username}}</a>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col v-if="selected">
          <b-card-group deck>
            <b-card :header="selected.username" v-if="users">
              <b-button variant="success" @click="save">Guardar</b-button>

              <b-form-checkbox v-model="selected.acceso_portal.superusuario" name="checkbox-1">
                Superusuario
              </b-form-checkbox>

              <hr>
              <label for="basic-url">Nombre</label>
              <input class="form-control" v-model="selected.first_name">
              <label for="basic-url">Apellido</label>
              <input class="form-control" v-model="selected.last_name">
              <label for="basic-url">Email</label>
              <input class="form-control" v-model="selected.email">
              <small>Sólo puede modificar los datos personales para usuarios clientes (es_cliente)</small>

              <hr>

              <b-form-group label="Seleccionar Módulos">
                <b-form-checkbox-group v-model="selected.acceso_portal.modulos" :options="modulos" stacked switches name="flavour-1"></b-form-checkbox-group>
              </b-form-group>
              <hr>
              <b-form-checkbox v-model="selected.acceso_portal.todas_direcciones" name="checkbox-1"> Todas las direcciones</b-form-checkbox>
              <div v-show="!selected.acceso_portal.todas_direcciones">

                <a href="#" @click="selectAll()" style="margin-right: 20px;">Seleccionar Todos</a>
                <a href="#" @click="selectNone()" style="margin-left: 20px;">Deseleccionar</a>
                <b-form-group label="Seleccionar Direcciones">
                  <b-form-input v-model="search_direccion" placeholder="Buscar..."></b-form-input>
                  <b-form-checkbox-group
                    v-model="selected.acceso_portal.direcciones" :options="getDirecciones()" value-field='id' text-field='text' stacked switches name="flavour-1"
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
// import PieChart from "@/views/PieChart.vue";

export default {
  name: 'Documentos',
  components: { },
  props: {
    msg: String
  },
  data () {
    return {
      users: [],
      direcciones: [],
      selected: null,
      search_user: '',
      search_direccion: '',
      modulos: ['cartola', 'documentos', 'rga', 'sinader', 'ecoequivalencia']
    }
  },
  methods: {
    getUsers () {
      return this.users.filter(item => {
        return item.username.toLowerCase().indexOf(this.search_user.toLowerCase()) > -1
      })
    },

    getDirecciones () {
      return this.direcciones.filter(item => {
        return item.text.toLowerCase().indexOf(this.search_direccion.toLowerCase()) > -1
      })
    },

    save () {
      axios.put(`/portal/permisos/users/${this.selected.id}/`, this.selected)
    },

    add () {
      var self = this
      var username = prompt('Ingrese nombre de usuario')
      if (username != null) {
        axios.post('/portal/permisos/users/', { username: username }).then(res => {
          self.search()
          self.search_user = username
        })
      }
    },

    selectAll () {
      this.selected.acceso_portal.direcciones = this.getDirecciones().map(function (el) { return el.id })
    },

    selectNone () {
      this.selected.acceso_portal.direcciones = []
    },

    search () {
      console.log('bsucando')
      var self = this
      axios.get('/portal/permisos/direcciones').then(function (res) { self.direcciones = res.data })
      axios.get('/portal/permisos/users').then(function (res) {
        res.data.forEach((value) => {
          value.acceso_portal = value.acceso_portal || {}
          value.acceso_portal.modulos = value.acceso_portal.modulos || []
          value.acceso_portal.direcciones = value.acceso_portal.direcciones || []
          value.acceso_portal.superusuario = value.acceso_portal.superusuario || false
        })

        self.users = res.data
      })
    }
  },
  mounted () {
    this.search()
  }
}
</script>
